import { gql } from "@apollo/client"

const GET_SITE_DATA_LESSONS_XLS_DOWNLOAD_LINK = gql`
  query GetLessonsXlsDownload($clientId: ID!) {
    dataLessonsXlsDownload(client_id: $clientId) {
      filename
      type
      url
      queued
    }
  }
`

export { GET_SITE_DATA_LESSONS_XLS_DOWNLOAD_LINK }
